import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="duplicate-element"
export default class extends Controller {
  static targets = ["element", "copyButton"]

  connect() {
    // We have to save the Node as it is immediately because child elements may have their own Stimulus controllers
    // on them and the contents of the element may change over time.
    this.savedElement = this.elementTarget.cloneNode(true);
  }
  copy(event) {
    event.preventDefault();
    const element = this.savedElement.cloneNode(true);
    this.elementTarget.insertAdjacentElement('afterend', element);
  }
}
